export default __webpack_public_path__ + "static/media/ic-profile.025e505b.svg";